import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Isvg from 'react-inlinesvg';
import { DESIGN_SYSTEM_ICONS } from 'constants/icons';
import css from './Location.scss';

export class Location extends PureComponent {
  handleRemoveClick = event => {
    event.stopPropagation();
    this.props.onRemoveClick(this.props.searchId);
  };

  render() {
    const {
      highlighted,
      searchId,
      item: { main_text: label, secondary_text: sublabel },
      onClick,
      onMouseDown,
      onMouseMove,
      role,
      'aria-selected': ariaSelected,
      id,
    } = this.props;

    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <li
        className={cx(css.base, {
          [css.isHighlighted]: highlighted,
        })}
        id={id}
        onClick={onClick}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        role={role}
        aria-selected={ariaSelected}>
        <Isvg className={css.icon} data-qa="Location.icon" src={DESIGN_SYSTEM_ICONS.pin} />
        <div className={css.content} data-qa="Location.content">
          <span className={css.label} data-qa="Location.label">
            {label}
          </span>
          {sublabel && (
            <span className={css.sublabel} data-qa="Location.sublabel">
              {sublabel}
            </span>
          )}
        </div>
        {searchId && (
          <div className={css.remove} data-qa="Location.remove" onClick={this.handleRemoveClick}>
            x
          </div>
        )}
      </li>
    );
  }
}

Location.propTypes = {
  highlighted: PropTypes.bool.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  item: PropTypes.shape({
    main_text: PropTypes.string.isRequired,
    secondary_text: PropTypes.string,
  }).isRequired,
  searchId: PropTypes.string,
  'aria-selected': PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onMouseMove: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};
